import {Routes} from '@angular/router';
import {AuthGuard} from '../../core/interceptors/auth.guard';
import {newBlockGuard} from '../../core/interceptors/new-block.guard';
import {GroupEstimate} from '../apiModule/model/groupEstimate';
import {Kind} from '../apiModule/model/kind';
import {RemarkType} from '../apiModule/model/remarktype';
import {SubgroupEstimate} from '../apiModule/model/subgroupEstimate';
import {RateCategory} from '../apiModule/model/rate-category';
import {rateCardIdResolver} from './rate-card/rate-card-id..resolver';
import {facilityResolver} from './register/resolvers/facility.resolver';
import {groupEstimateResolver} from './register/resolvers/group-estimate.resolver';
import {institutionsResolver} from './register/resolvers/institutions.resolver';
import {kindResolver} from './register/resolvers/kind.resolver';
import {remarksResolver} from './register/resolvers/remarks.resolver';
import {remarktypeResolver} from './register/resolvers/remarktype.resolver';
import {subgroupEstimateResolver} from './register/resolvers/subgroup-estimate.resolver';
import {rateCategoryResolver} from './register/resolvers/rate-category.resolver';
import {facilitySyncResolver} from './register/resolvers/facility-sync.resolver';

export const routes: Routes = [
    {
        path: 'login',
        title: 'Авторизация',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    },
    {
        path: 'logout',
        title: 'Авторизация',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
        resolve: {}
    },
    {
        path: 'register',
        title: 'Реестр оценок',
        loadComponent: () => import('./register/register.component').then(m => m.RegisterComponent),
        resolve: {
            remarks: remarksResolver
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'register/new',
        title: 'Реестр оценок',
        pathMatch: 'full',
        loadComponent: () => import('./grade/grade.component').then(m => m.GradeComponent),
        canActivate: [AuthGuard,],
    },
    {
        path: 'register/new/new', redirectTo: '/register/new',
    },
    {
        path: 'group',
        title: 'Группы замечаний',
        loadComponent: () => import('./register/register-group.component').then(m => m.RegisterGroupComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: groupEstimateResolver,
            newRemark: () => false,
            type: () => 'group'
        },
    },
    {
        path: 'group/:id',
        title: 'Группы замечаний',
        loadComponent: () => import('./register/register-group.component').then(m => m.RegisterGroupComponent),
        canActivate: [AuthGuard, newBlockGuard('group')],
        resolve: {
            remarks: groupEstimateResolver,
            newRemark: () => new GroupEstimate(),
            type: () => 'group'
        },
    },
    {
        path: 'subgroup',
        title: 'Подгруппы замечаний',
        loadComponent: () => import('./register/register-subgroup.component').then(m => m.RegisterSubroupComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: subgroupEstimateResolver,
            newRemark: () => false,
            type: () => 'subgroup'
        },
    },
    {
        path: 'subgroup/:id',
        title: 'Подгруппы замечаний',
        loadComponent: () => import('./register/register-subgroup.component').then(m => m.RegisterSubroupComponent),
        canActivate: [AuthGuard, newBlockGuard('subgroup')],
        resolve: {
            remarks: subgroupEstimateResolver,
            newRemark: () => new SubgroupEstimate(),
            type: () => 'subgroup'
        },
    },
    {
        path: 'kind',
        title: 'Виды замечаний',
        loadComponent: () => import('./register/register-kind.component').then(m => m.RegisterKindComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: kindResolver,
            newRemark: () => false,
            type: () => 'kind'
        },
    },
    {
        path: 'kind/:id',
        title: 'Виды замечаний',
        loadComponent: () => import('./register/register-kind.component').then(m => m.RegisterKindComponent),
        canActivate: [AuthGuard, newBlockGuard('kind')],
        resolve: {
            remarks: kindResolver,
            newRemark: () => new Kind(),
            type: () => 'kind'
        },
    },
    {
        path: 'remarktype',
        title: 'Замечания',
        loadComponent: () => import('./register/register-remarktype.component').then(m => m.RegisterRemarktypeComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: remarktypeResolver,
            newRemark: () => false,
            type: () => 'remarktype'
        },
    },
    {
        path: 'remarktype/:id',
        pathMatch: 'full',
        title: 'Замечания',
        loadComponent: () => import('./register/register-remarktype.component').then(m => m.RegisterRemarktypeComponent),
        canActivate: [AuthGuard, newBlockGuard('remarktype')],
        resolve: {
            remarks: remarktypeResolver,
            newRemark: () => new RemarkType(),
            type: () => 'remarktype'
        },
    },
    {
        path: 'remarktype/new/new',
        redirectTo: 'remarktype/new',
    },
    {
        path: 'ratecategory',
        title: 'Категории проверок',
        loadComponent: () => import('./register/register-rate-category.component').then(m => m.RegisterRateCategoryComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: rateCategoryResolver,
            newRemark: () => false,
            type: () => 'ratecategory'
        },
    },
    {
        path: 'ratecategory/:id',
        pathMatch: 'full',
        title: 'Категории проверок',
        loadComponent: () => import('./register/register-rate-category.component').then(m => m.RegisterRateCategoryComponent),
        canActivate: [AuthGuard, newBlockGuard('ratecategory')],
        resolve: {
            remarks: rateCategoryResolver,
            newRemark: () => new RateCategory(),
            type: () => 'ratecategory'
        },
    },
    {
        path: 'ratecategory/new/new',
        redirectTo: 'ratecategory/new',
    },
    {
        path: 'institutions',
        title: 'Учреждения Москомспорта',
        loadComponent: () => import('./register/register-institutions.component').then(m => m.RegisterInstitutionsComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: institutionsResolver,
            newRemark: () => false,
        },
    },
    {
        path: 'facility',
        title: 'Объекты учреждений Москомспорта',
        loadComponent: () => import('./register/register-facility.component').then(m => m.RegisterFacilityComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: facilityResolver,
            newRemark: () => false,
        },
    },
    {
        path: 'facility-sync',
        title: 'Объекты учреждений Москомспорта',
        loadComponent: () => import('./register/register-facility.component').then(m => m.RegisterFacilityComponent),
        canActivate: [AuthGuard],
        resolve: {
            remarks: facilitySyncResolver,
            newRemark: () => false,
        },
    },
    {
        path: 'ratecard',
        title: 'Реестр оценок',
        loadComponent: () => import('./rate-card/rate-card.component').then(m => m.RateCardComponent),
        canActivate: [AuthGuard],
        resolve: {}
    },
    {
        path: 'ratecard/new', redirectTo: '/grade',
    },
    {
        path: 'grade',
        title: 'Новая оценка',
        loadComponent: () => import('./grade/grade.component').then(m => m.GradeComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'grade/:id',
        title: 'Оценка',
        loadComponent: () => import('./grade/grade.component').then(m => m.GradeComponent),
        canActivate: [AuthGuard],
        resolve: {
            data: rateCardIdResolver,
        },
    },
    {
        path: 'grade/new', redirectTo: '/grade',
    },
    {
        path: 'rating',
        title: 'Рейтинг',
        loadComponent: () => import('./rating/rating.component').then(m => m.RatingComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'org-rating',
        title: 'Рейтинг',
        loadComponent: () => import('./rating/org-rating.component').then(m => m.OrgRatingComponent),
        canActivate: [AuthGuard],
    },
    {
        path: 'dashboard',
        title: 'Дашборд',
        loadComponent: () => import('./swiping-dashboard/swiping-dashboard.component').then(m => m.SwipingDashboardComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'users',
        title: 'Администрирование',
        loadComponent: () => import('./users/users.component').then(m => m.UsersComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'users/:id',
        title: 'Администрирование',
        loadComponent: () => import('./users/users.component').then(m => m.UsersComponent),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'restore-password',
        title: 'Восстановление пароля',
        loadComponent: () => import('./restore-password/restore-password.component').then(m => m.RestorePasswordComponent),
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: '404',
        loadComponent: () => import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
        title: 'Страница не найдена'
    },
    {
        path: '**',
        redirectTo: '/404'
    }
];
